import axios from "axios";

import { router } from "./router";

const baseURL = process.env.VUE_APP_CHATBOT_BASE_API_URL || "";

function api() {
  const apiToken = sessionStorage.getItem("chatbotToken");
  const api = axios.create({
    baseURL,
    headers: { CleverCareApiToken: apiToken }
  });

  api.interceptors.response.use(
    res => res,
    err => {
      if (err.response.status === 401) {
        router.replace("/login");
        return;
      }
      throw err;
    }
  );
  return api;
}

export default {
  async listHistory({
    startDate: data_inicio,
    endDate: data_fim,
    limit: limite = 50,
    ascending: order_ASC = false,
    lastMessageId: idultimaMensagem = null
  }) {
    const response = await api().get("/mensagens/historico", {
      params: {
        ...(data_inicio ? { data_inicio } : {}),
        ...(data_fim ? { data_fim } : {}),
        ...(limite ? { limite } : {}),
        ...(order_ASC ? { order_ASC } : {}),
        ...(idultimaMensagem ? { idultimaMensagem } : {})
      }
    });

    if (!response.data.sucesso) {
      throw new Error("response data success is false");
    }
    return response.data.resposta;
  },
  async getChoices({ messageId }) {
    const response = await api().get(`/mensagens/${messageId}/opcoes_resposta`);

    if (!response.data.sucesso) {
      throw new Error("response data success is false");
    }

    return response.data.resposta;
  },
  async sendTextAnswer({ text: texto }) {
    const response = await api().post("/mensagens/mensagem", { texto });
    return response;
  },
  async sendChoiceAnswer({ messageId, choiceId: id, choiceText: texto }) {
    const response = await api().post(
      `/mensagens/${messageId}/responder_arco`,
      {
        id,
        texto
      }
    );

    if (!response.data.sucesso) {
      throw new Error("response data success is false");
    }
    return response.data.resposta;
  },
  async getConfig() {
    const response = await api().get("/obterPersonalizacaoGrupo");
    return response.data;
  }
};
